<template>
  <a-card class="Statistics">
    <div v-if="pageLoading" class="loadingPage">
      <a-spin/>
    </div>
    <div>
      <div class="evaluationgames" v-if="$route.query.type == 1">
        <div class="btn-group" style="display:flex;">
          <a-button-group style="margin-right: 30px;">
            <a-button :type="date.currentDateType === index ? 'primary' : 'default'"
                      @click="dateChange(index)"
                      :key="index"
                      v-for="(item, index) in date.dateType">
              {{ item }}
            </a-button>
          </a-button-group>
          <a-range-picker
            @ok="pickerChange"
            v-model="date.data"
            show-time
            :format="date.dateFormat"
            :disabled-date="current => current && current > (new Date().getTime())"/>
          <a-button-group style="margin-left: 30px;">
            <a-button :type="currentAbnormal === index ? 'primary' : 'default'"
                      @click="abnormalChange(index)"
                      :key="index"
                      v-for="(item, index) in abnormals">
              {{ item }}
            </a-button>
          </a-button-group>
          <a-form-model layout="inline" style="margin-left: 50px;">
            <a-form-model-item label="版本名称">
              <a-select style="min-width: 180px" allowClear @change="handleChange" v-model="eSearchForm.contentVersion"
                        placeholder="请选择版本名称">
                <a-select-option :value="item.version" v-for="item in versionList">{{ item.version }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </div>
        <div>
          <p>不同年龄的使用人数分布 <span style="color: #f00;"
                               v-if="Evaluationgames.total > 0">({{ Evaluationgames.total }}人)</span></p>
          <div class="chart">
            <div ref="EuseCountChart" style="height: 300px;"></div>
            <div style="height: 300px;" v-show="areAllArraysZero(Evaluationgames.usageNum)" class="noData">
              无不同年龄的使用人数分布数据
            </div>
          </div>
          <p>各年龄的作答时间分布 <span style="color: #f00;"
                              v-if="Evaluationgames.averTimes > 0">({{ EstimatedTime(Evaluationgames.averTimes) }})</span>
          </p>
          <div class="chart">
            <div ref="EtimeConsumingChart" style="height: 300px;"></div>
            <div style="height: 300px;" v-show="areAllArraysZero(Evaluationgames.timeConsuming)" class="noData">
              无各年龄的作答时间分布数据
            </div>
          </div>
          <p>各年龄的正确率分布</p>
          <div class="stag" style="display: flex;">
            <a-form-model-item label="筛选正确率" :label-col="{span: 6}" :wrapper-col="{span: 18}" style="width: 400px;">
              <a-input-group compact>
                <a-input style=" width: 100px; text-align: center" v-model="eSearchForm.minAccuracy" :min="1" :max="100"
                         placeholder="最小正确率"/>
                <a-input
                  style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                  placeholder="~"
                  disabled
                />
                <a-input style="width: 100px; text-align: center; border-left: 0" min="eSearchForm.minAccuracy + 1"
                         :max="100" v-model="eSearchForm.maxAccuracy" placeholder="最大正确率"/>
              </a-input-group>
            </a-form-model-item>
          </div>
          <div class="chart">
            <div ref="EAccuracyChart" style="height: 300px;"></div>
            <div style="height: 300px;" v-show="areAllArraysNonEmpty(Evaluationgames.ageAccuracyList)" class="noData">
              无各年龄的正确率分布数据
            </div>
          </div>
        </div>
      </div>
      <a-modal v-model="Evaluationgames.visible" :title="Evaluationgames.tit + ' 各作答时间的人次分布'" :footer="null"
               width="50%">
        <div ref="EtimeConsumingDetailChart" style="height: 300px;"></div>
      </a-modal>
      <div class="traingames" v-if="$route.query.type == 2">
        <div class="head">
          <div class="stag" style="display: flex;">
            <a-form-model-item label="筛选关卡" :label-col="{span: 6}" :wrapper-col="{span: 18}" style="width: 400px;">
              <a-input-group compact>
                <a-input style=" width: 100px; text-align: center" v-model="eSearchForm.minStage" :min="1" :max="150"
                         placeholder="最小关卡"/>
                <a-input
                  style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                  placeholder="~"
                  disabled
                />
                <a-input style="width: 100px; text-align: center; border-left: 0" min="eSearchForm.minStage + 1"
                         :max="150" v-model="eSearchForm.maxStage" placeholder="最大关卡"/>
              </a-input-group>
            </a-form-model-item>
            <a-button-group>
              <a-button :type="currentAbnormal === index ? 'primary' : 'default'"
                        @click="abnormalChange(index)"
                        :key="index"
                        v-for="(item, index) in abnormals">
                {{ item }}
              </a-button>
            </a-button-group>

            <a-form-model layout="inline" style="margin-left: 50px;">
              <a-form-model-item label="版本名称" class="vename">
                <a-select style="min-width: 180px" allowClear @change="handleChange"
                          v-model="eSearchForm.contentVersion"
                          placeholder="请选择版本名称">
                  <a-select-option :value="item.version" v-for="item in versionList">{{ item.version }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-form-model>
          </div>
          <div class="btn-group">
            <a-button-group>
              <a-button :type="date.currentDateType === index ? 'primary' : 'default'"
                        @click="dateChange(index)"
                        :key="index"
                        v-for="(item, index) in date.dateType">
                {{ item }}
              </a-button>
            </a-button-group>
            <a-range-picker
              @ok="pickerChange"
              v-model="date.data"
              show-time
              :default-value="[eSearchForm.startTime, eSearchForm.endTime]"
              :format="date.dateFormat"
              :disabled-date="current => current && current > (new Date().getTime())"/>

          </div>

        </div>
        <div :key="keys">
          <p>不同年龄的使用人数分布 <span style="color: #f00;" v-if="Traingames.total > 0">({{ Traingames.total }}人)</span></p>
          <div class="chart">
            <div ref="TuseCountChart" style="height: 300px;"></div>
            <div style="height: 300px;" v-show="areAllArraysZero(Traingames.usageNum)" class="noData">无不同年龄的使用人数分布数据
            </div>
          </div>

          <p>各关卡的作答时间分布 <span style="color: #f00;"
                              v-if="Traingames.averTimes > 0">({{ EstimatedTime(Traingames.averTimes) }})</span></p>
          <div style="display: flex;">
            <a-form-model-item label="年龄" :label-col="{span: 6}" :wrapper-col="{span: 18}"
                               style="width: 300px;margin-top: -5px;">
              <a-input-number v-model="timeAge" :min="1" :max="100" @change="answeringTimeUpdate"/>
            </a-form-model-item>
          </div>
          <div class="chart">
            <div ref="TtimeConsumingChart" style="height: 300px;"></div>
            <div style="height: 300px;" v-show="areAllArraysZero(Traingames.timeConsuming)" class="noData">
              无关卡的作答时间分布数据
            </div>
          </div>

          <div>
            <p>各关卡的作答次数分布</p>
            <div style="display: flex;">
              <a-form-model-item label="筛选次数" :label-col="{span: 6}" :wrapper-col="{span: 18}"
                                 style="width: 400px;margin-top: -5px;margin-left: 30px;">
                <a-input-group compact>
                  <a-input-number style=" width: 100px; text-align: center" v-model="eSearchForm.minCompleteCount"
                                  @change="answeringNumberUpdate"
                                  :min="1" :max="100" placeholder="最小次数"/>
                  <a-input
                    style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                    placeholder="~"
                    disabled
                  />
                  <a-input-number style="width: 100px; text-align: center; border-left: 0"
                                  :min="eSearchForm.minCompleteCount" :max="100" @change="answeringNumberUpdate"
                                  v-model="eSearchForm.maxCompleteCount" placeholder="最大次数"/>
                </a-input-group>
              </a-form-model-item>
              <a-form-model-item label="年龄" :label-col="{span: 6}" :wrapper-col="{span: 10}"
                                 style="width: 300px;margin-top: -5px;">
                <a-input-number v-model="answerAge" :min="1" :max="100" @change="answeringNumberUpdate"/>
              </a-form-model-item>
              <a-form-model-item label="是否通关" :label-col="{span: 6}" :wrapper-col="{span: 10}"
                                 style="width: 300px;margin-top: -5px;">
                <a-select style="width: 100%" v-model="eSearchForm.isClearance" allowClear placeholder="全部"
                          @change="getTraingames('answer')">
                  <a-select-option value="true">
                    已通过
                  </a-select-option>
                  <a-select-option value="false">
                    未通过
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </div>
            <div v-if="answer.xAxisData.length > 0">
              <div ref="answerCharDom" style="height: 300px;"></div>
            </div>
            <div v-else style="height: 300px; text-align: center; line-height: 300px;">
              无关卡各关卡的作答次数分布数据
            </div>
          </div>

          <p>各关卡的星星数分布</p>
          <div style="display: flex;">
            <a-radio-group style="margin-left: 60px;" v-model="isFirst.star" @change="statNumberUpdate"
                           button-style="solid" key="1">
              <a-radio-button :value="true">
                首次
              </a-radio-button>
              <a-radio-button :value="false">
                全部
              </a-radio-button>
            </a-radio-group>
            <a-form-model-item label="年龄" :label-col="{span: 6}" :wrapper-col="{span: 18}"
                               style="width: 300px;margin-top: -5px;">
              <a-input-number v-model="startAge" :min="1" :max="100" @change="statNumberUpdate"/>
            </a-form-model-item>
          </div>

          <div class="chart">
            <div ref="TStartChart" style="height: 300px;"></div>
            <div style="height: 300px;" v-show="areAllArraysNonEmpty(Traingames.stageStarList)" class="noData">
              无关卡的星星数分布数据
            </div>
          </div>

          <p>各关卡的正确率分布</p>
          <div style="display: flex;">
            <a-radio-group style="margin-left: 60px;" v-model="isFirst.accuracy" key="2"
                           @change="accuracyUpdate" button-style="solid">
              <a-radio-button :value="true">
                首次
              </a-radio-button>
              <a-radio-button :value="false">
                全部
              </a-radio-button>
            </a-radio-group>
            <a-form-model-item label="筛选正确率" :label-col="{span: 6}" :wrapper-col="{span: 18}"
                               style="width: 400px;margin-top: -5px;margin-left: 30px;">
              <a-input-group compact>
                <a-input-number style=" width: 100px; text-align: center" v-model="eSearchForm.minAccuracy" :min="1"
                                :max="100" placeholder="最小正确率"/>
                <a-input
                  style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                  placeholder="~"
                  disabled
                />
                <a-input-number style="width: 100px; text-align: center; border-left: 0"
                                :min="eSearchForm.minAccuracy + 1" :max="100" v-model="eSearchForm.maxAccuracy"
                                placeholder="最大正确率"/>
              </a-input-group>
            </a-form-model-item>
            <a-form-model-item label="年龄" :label-col="{span: 6}" :wrapper-col="{span: 10}"
                               style="width: 300px;margin-top: -5px;">
              <a-input-number v-model="accuracyAge" :min="1" :max="100" @change="accuracyUpdate"/>
            </a-form-model-item>
          </div>
          <div class="chart">
            <div ref="TAccuracyChart" style="height: 300px;"></div>
            <div style="height: 300px;" v-show="areAllArraysNonEmpty(Traingames.AccuracyList)" class="noData">
              无关卡的正确率分布数据
            </div>
          </div>
        </div>
      </div>
      <a-modal v-model="Traingames.visible" :title="Traingames.tit + ' 各作答时间的人次分布'" :footer="null" width="50%">
        <div ref="TtimeConsumingDetailChart" style="height: 300px;"></div>
      </a-modal>
    </div>
  </a-card>
</template>

<script>
import moment from 'moment';
import {EstimatedTime} from "@/utils/EstimatedTime";
import $Bus from "@/pages/projectImpl/js/eventBus";

export default {
  name: 'Statistics',
  data() {
    return {
      pageLoading: true,
      EstimatedTime,
      moment,
      date: {
        dateType: ['30天', '90天', '360天', '全部'],
        currentDateType: 3,
        dateFormat: 'YYYY-MM-DD',
        data: []
      },
      info: this.$route.query.type == 1 ? this.$store.getters["content/getEvaluationGameInfo"]() : this.$store.getters["content/getTrainGameInfo"](),
      eSearchForm: {
        age: undefined,
        minStage: undefined,
        maxStage: undefined,
        minAccuracy: '',
        maxAccuracy: '',
        startTime: undefined,
        endTime: undefined,
        isFirst: true,
        hasAbnormal: false,
        contentVersion: undefined,
        minCompleteCount: undefined,
        maxCompleteCount: undefined,
        isClearance: undefined,
      },
      abnormals: ['全部', '无异常值'],
      currentAbnormal: 1,
      Evaluationgames: {
        visible: false,
        tit: '',
        ages: [],//年龄
        usageNum: [],//使用人数
        timeConsuming: [],//作答时间
        ageAccuracyList: {
          a: [],
          b: [],
          c: [],
          d: [],
          e: [],
          f: []
        },
        total: 0,
        averTimes: 0
      },
      Traingames: {
        visible: false,
        tit: '',
        age: [],//年龄
        usageNum: [],//使用人数
        stage: [],//关卡
        timeConsuming: [],//作答时间
        // 星星数
        stageStarList: {
          a: [],
          b: [],
          c: [],
          d: [],
        },
        // 正确率
        AccuracyList: {
          a: [],
          b: [],
          c: [],
          d: [],
          e: [],
          f: []
        },

        total: 0,
        averTimes: 0
      },
      currentStart: 0,
      timeAge: undefined,
      startAge: undefined,
      accuracyAge: undefined,
      answerAge: undefined,
      isFirst: {
        star: true,
        accuracy: true,
      },

      versionList: [],
      keys: Date.now(),
      answer: {
        xAxisData: [],
        legend: [1, 2, 3, 4, 5, 6],
        series: []
      }
    }
  },
  watch: {
    'eSearchForm.minStage'(val) {
      this.resetSearch();
      this.getTraingames()
    },
    'eSearchForm.maxStage'(val) {
      this.resetSearch();
      this.getTraingames()
    },
    'eSearchForm.minAccuracy'(val) {
      if (this.$route.query.type == 1) {
        this.getEvaluationgames()
      } else {
        this.accuracyUpdate()
      }
    },
    'eSearchForm.maxAccuracy'(val) {
      if (this.$route.query.type == 1) {
        this.getEvaluationgames()
      } else {
        this.accuracyUpdate()
      }
    }
  },
  mounted() {
    this.getVerSions()

    this.setTitle()

  },
  methods: {
    resetSearch() {
      this.eSearchForm.age = undefined;
      this.accuracyAge = undefined;
      this.startAge = undefined;
      this.timeAge = undefined;
      this.answerAge = undefined;
      this.eSearchForm.minAccuracy = undefined;
      this.eSearchForm.maxAccuracy = undefined;
      this.eSearchForm.minCompleteCount = undefined;
      this.eSearchForm.maxCompleteCount = undefined;
      this.eSearchForm.isFirst = true;
      this.keys = Date.now();
    },
    getVerSions() {
      let params = {
        id: this.info.id,
      }
      this.$http.EGamegeVersion(params)
        .then(res => {
            this.versionList = res.data.data
            this.eSearchForm.contentVersion = res.data.data.filter(f => f.enabled)[0].version
            if (this.$route.query.type == 1) {
              this.getEvaluationgames()
            } else {
              this.getTraingames()
            }
        })
    },
    setTitle() {
      let tabName = ''
      if (this.$route.query.versionName) {
        tabName = this.$route.query.name + '-' + this.$route.query.versionName + '-统计详情'
      } else {
        tabName = this.$route.query.name + '-统计详情'
      }

      $Bus.$emit("pageHeaderTitle", tabName);
    },
    // 判断是否有值
    areAllArraysNonEmpty(obj) {
      return Object.values(obj).every(arr => arr.length === 0);
    },
    // 判断是否为0
    areAllArraysZero(obj) {
      return obj.every(m => m === 0);
    },
    // 获取xx天前
    getBeforeDate(date) {
      let data = date;
      let d = new Date();
      let year = d.getFullYear();
      let mon = d.getMonth() + 1;
      let day = d.getDate();
      if (day <= data) {
        if (mon > 1) {
          mon = mon - 1;
        } else {
          year = year - 1;
          mon = 12;
        }
      }
      d.setDate(d.getDate() - data);
      year = d.getFullYear();
      mon = d.getMonth() + 1;
      day = d.getDate();
      let s =
        year +
        "-" +
        (mon < 10 ? "0" + mon : mon) +
        "-" +
        (day < 10 ? "0" + day : day);
      return s;
    },
    dateChange(e) {
      this.resetSearch();
      this.date.currentDateType = e
      if (e == 0) {
        this.eSearchForm.startTime = this.getBeforeDate(30)
      }
      if (e == 1) {
        this.eSearchForm.startTime = this.getBeforeDate(90)
      }
      if (e == 2) {
        this.eSearchForm.startTime = this.getBeforeDate(360)
      }
      this.eSearchForm.endTime = this.getBeforeDate(0)
      if (e == 3) {
        this.eSearchForm.startTime = undefined
        this.eSearchForm.endTime = undefined
      } else {
        // this.date.data = [moment(this.eSearchForm.startTime), moment(this.eSearchForm.endTime)]
      }
      this.date.data = []
      if (this.$route.query.type == 1) {
        this.getEvaluationgames()
      } else {
        this.getTraingames()
      }
    },
    abnormalChange(e) {
      this.resetSearch();
      this.currentAbnormal = e
      this.eSearchForm.hasAbnormal = e == 0 ? true : false
      if (this.$route.query.type == 1) {
        this.getEvaluationgames()
      } else {
        this.getTraingames()
      }
    },
    pickerChange(val) {
      if (Array.isArray(val) && val.length) {
        this.eSearchForm.startTime = val[0].format('YYYY-MM-DD');
        this.eSearchForm.endTime = val[1].format('YYYY-MM-DD');
      } else {
        this.eSearchForm.startTime = undefined;
        this.eSearchForm.endTime = undefined;
      }

      if (this.$route.query.type == 1) {
        this.getEvaluationgames()
      } else {
        this.getTraingames()
      }
    },

    // 作答时间分布更新
    answeringTimeUpdate(){
      const Params = {
        age: this.timeAge,
        minCompleteCount: undefined,
        maxCompleteCount: undefined,
        isClearance: undefined,
        minAccuracy: undefined,
        maxAccuracy: undefined,
        isFirst: undefined,
      }
      this.getTraingames('time', Params)
    },
    // 作答次数分布更新
    answeringNumberUpdate(){
      const Params = {
        age: this.answerAge,
        minCompleteCount: this.eSearchForm.minCompleteCount,
        maxCompleteCount: this.eSearchForm.maxCompleteCount,
        isClearance: this.eSearchForm.isClearance,
        minAccuracy: undefined,
        maxAccuracy: undefined,
        isFirst: undefined,
      }
      this.getTraingames('answer', Params)
    },
    // 星星数分布更新
    statNumberUpdate(){
      const Params = {
        age: this.startAge,
        minCompleteCount: undefined,
        maxCompleteCount: undefined,
        isClearance: undefined,
        minAccuracy: undefined,
        maxAccuracy: undefined,
        isFirst: this.isFirst.star,
      }
      this.getTraingames('start', Params)
    },
    // 正确率分布更新
    accuracyUpdate(){
      const Params = {
        age: this.accuracyAge,
        minCompleteCount: undefined,
        maxCompleteCount: undefined,
        isClearance: undefined,
        minAccuracy: this.eSearchForm.minAccuracy,
        maxAccuracy: this.eSearchForm.maxAccuracy,
        isFirst: this.isFirst.accuracy,
      }
      this.getTraingames('accuracy', Params)
    },

    EvaluationgamesClose() {
      this.Evaluationgames.total = 0
      this.Evaluationgames.ages = []
      this.Evaluationgames.usageNum = []
      this.Evaluationgames.timeConsuming = []
      this.Evaluationgames.ageAccuracyList = {
        a: [],
        b: [],
        c: [],
        d: [],
        e: [],
        f: []
      };
    },
    TraingamesClose() {
      this.Traingames.total = 0
      this.Traingames.age = []
      this.Traingames.stage = []
      this.Traingames.usageNum = []
      this.Traingames.timeConsuming = []
      this.Traingames.stageStarList = {
        a: [],
        b: [],
        c: [],
        d: []
      };
      this.Traingames.AccuracyList = {
        a: [],
        b: [],
        c: [],
        d: [],
        e: [],
        f: []
      };
    },
    handleChange() {
      this.resetSearch();
      if (this.$route.query.type == 1) {
        this.getEvaluationgames()
      } else {
        this.getTraingames()
      }
    },
    // 获取测评游戏统计数据
    getEvaluationgames(name) {
      this.Evaluationgames.total = 0
      let params = {
        contentId: this.info.id,
        contentVersion: this.eSearchForm.contentVersion,
        ...this.eSearchForm
      }
      // this.pageLoading = true
      this.$http.GetContentStatistics(params)
        .then(res => {
          this.pageLoading = false
          this.$message.destroy();
          const {status, data, message} = res.data;
          this.EvaluationgamesClose();
          let Data = []
          let averTimes = []
          Data = JSON.parse(JSON.stringify(data))
          Data.forEach((v, i) => {
            this.Evaluationgames.ages.push(v.age)
            this.Evaluationgames.usageNum.push(v.usageNum)
            this.Evaluationgames.timeConsuming.push(v.timeConsuming)
            if (v.ageAccuracyList.length) {
              v.ageAccuracyList.forEach(m => {
                let str = {
                  value: m.count,
                  accuracy: m.accuracy
                }
                if (m.level == 0) {
                  this.Evaluationgames.ageAccuracyList.f.length = this.Evaluationgames.ages.length - 1
                  this.Evaluationgames.ageAccuracyList.f.push(str)
                }
                if (m.level == 1) {
                  this.Evaluationgames.ageAccuracyList.a.length = this.Evaluationgames.ages.length - 1
                  this.Evaluationgames.ageAccuracyList.a.push(str)
                }
                if (m.level == 2) {
                  this.Evaluationgames.ageAccuracyList.b.length = this.Evaluationgames.ages.length - 1
                  this.Evaluationgames.ageAccuracyList.b.push(str)
                }
                if (m.level == 3) {
                  this.Evaluationgames.ageAccuracyList.c.length = this.Evaluationgames.ages.length - 1
                  this.Evaluationgames.ageAccuracyList.c.push(str)
                }
                if (m.level == 4) {
                  this.Evaluationgames.ageAccuracyList.d.length = this.Evaluationgames.ages.length - 1
                  this.Evaluationgames.ageAccuracyList.d.push(str)
                }
                if (m.level == 5) {
                  this.Evaluationgames.ageAccuracyList.e.length = this.Evaluationgames.ages.length - 1
                  this.Evaluationgames.ageAccuracyList.e.push(str)
                }
              })
            }
            if (v.timeConsuming > 0) {
              averTimes.push(v.timeConsuming)
            }
          })
          this.Evaluationgames.total = this.Evaluationgames.usageNum.reduce((acc, cur) => acc + cur, 0);
          this.Evaluationgames.averTimes = averTimes.reduce((acc, cur) => acc + cur, 0) / averTimes.length;
          ;
          console.log(name);
          this.initEUseCount();
          this.initETimeConsuming();
          this.initEAccuracy();
        })
    },
    // 获取训练游戏统计数据
    getTraingames(name, _params = {}) {
      let stage = this.Traingames.stage
      let params = {
        ...this.eSearchForm,
        ..._params,
        contentId: this.info.id,
        // contentVersion:this.eSearchForm.contentVersion,
      }
      // this.pageLoading = true
      this.$http.GetTrainContentStatistics(params)
        .then(res => {
          this.pageLoading = false
          this.$message.destroy();
          const {status, data, message} = res.data;
          if (name == 'answer') {
            this.loadAnswerData(data);
            return
          }
          if (name == 'start') {
            this.Traingames.stageStarList = {
              a: [],
              b: [],
              c: [],
              d: []
            };
            this.Traingames.age = []
            this.Traingames.stage = []
            this.Traingames.usageNum = []
          } else if (name == 'accuracy') {
            this.Traingames.AccuracyList = {
              a: [],
              b: [],
              c: [],
              d: [],
              e: [],
              f: []
            };
            this.Traingames.age = []
            this.Traingames.stage = []
            this.Traingames.usageNum = []
          } else if (name == 'time') {
            this.Traingames.timeConsuming = []
            this.Traingames.age = []
            this.Traingames.stage = []
            this.Traingames.usageNum = []
          } else {
            this.TraingamesClose();
          }

          data.ageUsageList.forEach(v => {
            this.Traingames.age.push(v.age)
            this.Traingames.usageNum.push(v.usageNum)
          })
          this.Traingames.averTimes = 0;
          this.Traingames.total = this.Traingames.usageNum.reduce((acc, cur) => acc + cur, 0)
          const ageObj = [], ageValueObj = {};
          const stage = data.stageInfoList.map(v => {
            for (let i = 0; i < v.timeConsumingList.length; i++) {
              if (ageObj.indexOf(v.timeConsumingList[i].age) === -1) {
                ageObj.push(v.timeConsumingList[i].age);
              }
            }
            return v.stage;
          });
          ageObj.forEach(f => {
            data.stageInfoList.forEach(f1 => {
              const timeConsuming = f1.timeConsumingList.filter(f2 => f2.age === f)[0];
              if (Array.isArray(ageValueObj[f])) {
                ageValueObj[f].push(timeConsuming ? timeConsuming.timeConsuming : 0)
              } else {
                ageValueObj[f] = [timeConsuming ? timeConsuming.timeConsuming : 0]
              }
            })

          });
          if (data.stageInfoList.length) {
            let averTimes = []
            data.stageInfoList.forEach(v => {
              v.timeConsumingList.forEach(m => {
                this.Traingames.timeConsuming.push(m.timeConsuming)
                if (m.timeConsuming > 0) {
                  averTimes.push(m.timeConsuming)
                }
              })
              this.Traingames.stage.push(v.stage)
              if (v.stageStarList.length && name != 'accuracy') {
                v.stageStarList.forEach(n => {
                  if (n.star == 0) {
                    this.Traingames.stageStarList.a.length = this.Traingames.stage.length - 1
                    this.Traingames.stageStarList.a.push(n.count)
                  }
                  if (n.star == 1) {
                    this.Traingames.stageStarList.b.length = this.Traingames.stage.length - 1
                    this.Traingames.stageStarList.b.push(n.count)
                  }
                  if (n.star == 2) {
                    this.Traingames.stageStarList.c.length = this.Traingames.stage.length - 1
                    this.Traingames.stageStarList.c.push(n.count)
                  }
                  if (n.star == 3) {
                    this.Traingames.stageStarList.d.length = this.Traingames.stage.length - 1
                    this.Traingames.stageStarList.d.push(n.count)
                  }
                })
              }
              if (v.stageAccuracyList.length && name != 'start') {
                v.stageAccuracyList.forEach(n => {
                  let str = {
                    value: n.count,
                    accuracy: n.accuracy
                  }
                  if (n.level == 0) {
                    this.Traingames.AccuracyList.f.length = this.Traingames.stage.length - 1
                    this.Traingames.AccuracyList.f.push(str)
                  }
                  if (n.level == 1) {
                    this.Traingames.AccuracyList.a.length = this.Traingames.stage.length - 1
                    this.Traingames.AccuracyList.a.push(str)
                  }
                  if (n.level == 2) {
                    this.Traingames.AccuracyList.b.length = this.Traingames.stage.length - 1
                    this.Traingames.AccuracyList.b.push(str)
                  }
                  if (n.level == 3) {
                    this.Traingames.AccuracyList.c.length = this.Traingames.stage.length - 1
                    this.Traingames.AccuracyList.c.push(str)
                  }
                  if (n.level == 4) {
                    this.Traingames.AccuracyList.d.length = this.Traingames.stage.length - 1
                    this.Traingames.AccuracyList.d.push(str)
                  }
                  if (n.level == 5) {
                    this.Traingames.AccuracyList.e.length = this.Traingames.stage.length - 1
                    this.Traingames.AccuracyList.e.push(str)
                  }
                })
              }
            })
            this.Traingames.averTimes = averTimes.reduce((acc, cur) => acc + cur, 0) / averTimes.length;
          } else {
            this.Traingames.stage = stage
          }
          if (!name || name == 'start') {
            this.initTStart();
          }
          if (!name || name == 'accuracy') {
            this.initTAccuracy();
          }
          if (!name || name == 'time') {
            this.initTimeConsuming(stage, ageValueObj);
          }
          if (!name) {
            this.loadAnswerData(data);
            this.initTUseCount();
          }
        })
    },
    loadAnswerData(data) {
      this.answer.xAxisData = data.stageInfoList.map(v => '关卡：' + v.stage);
      this.answer.series = this.answer.legend
        .filter(f => f >= (this.eSearchForm.minCompleteCount || 0) && f <= (this.eSearchForm.maxCompleteCount || 9999)).map(name => {
          return {
            name: name <= 5 ? name + "次" : "5次以上",
            type: 'bar',
            stack: 'total',
            emphasis: {
              focus: 'series'
            },
            data: data.stageInfoList.map(m1 => {
              for (let i = 0; i < m1.stageCompleteInfoList.length; i++) {
                const item = m1.stageCompleteInfoList[i];
                if (name === item.completeNum || (name > 5 && item.completeNum > 5)) {
                  return item.count
                }
              }
              return 0;
            })
          }
        })
      this.answerChart();
    },
    /**
     * 测评游戏
     *
     */
    // 使用人数分布
    initEUseCount() {
      this.$echarts.init(this.$refs.EuseCountChart).setOption({
        grid: {
          left: 60,
          right: 40,
          top: 40,
          bottom: 40,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          className: "echarts-tooltip",
          formatter: function (val) {
            return `
						<div>年龄: ${val[0].name}</div>
						<div>人数: <span>${val[0].value}</span></div>
						`
          }
        },
        xAxis: {
          name: '年龄',
          type: 'category',
          data: this.Evaluationgames.ages,
          boundaryGap: false,
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          nameGap: 25,
          name: '使用人数',
          type: 'value'
        },
        series: [
          {
            data: this.Evaluationgames.usageNum,
            type: 'line',
            smooth: true,
            showSymbol: false,
            lineStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                offset: 0,
                color: 'rgba(44,233,255)'
              }, {
                offset: 1,
                color: 'rgb(112,66,251)'
              }])
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(32,203,255, 0.4)'
              }, {
                offset: 1,
                color: 'rgba(32,203,255, 0)'
              }])
            }
          }
        ]
      })
    },
    // 作答时间分布
    initETimeConsuming() {
      let ETimeConsuming = this.$echarts.init(this.$refs.EtimeConsumingChart)
      let that = this
      ETimeConsuming.on("click", function (event) {

        that.getETimeDetail(event)
      })
      this.$echarts.init(this.$refs.EtimeConsumingChart).setOption({
        tooltip: {
          trigger: 'axis',
          formatter: function (val) {
            let time = val[0].value == 0 ? 0 : that.EstimatedTime(val[0].value);
            return `
						<div>年龄: ${val[0].name}</div>
						<div>平均作答时间: <span>${time}</span></div>
						`
          }
        },
        grid: {
          left: 60,
          right: 40,
          top: 40,
          bottom: 40,
        },
        xAxis: {
          name: '年龄',
          type: 'category',
          data: this.Evaluationgames.ages,
        },
        yAxis: {
          name: '平均作答时间',
          type: 'value'
        },
        series: [
          {
            type: 'bar',
            data: this.Evaluationgames.timeConsuming
          },
        ]
      })
    },
    getETimeDetail(event) {
      let params = {
        contentId: this.info.id,
        contentVersion: this.eSearchForm.contentVersion,
        StartTime: this.eSearchForm.startTime,
        EndTime: this.eSearchForm.endTime,
        type: 2,
        age: event.name
      }
      this.$http.GetContentStatisticsByAge(params)
        .then(res => {
          this.$message.destroy();
          const {status, data, message} = res.data;
          if (status && data.length) {
            this.Evaluationgames.visible = true
            this.Evaluationgames.tit = event.name + '岁'
            let xData = []
            let yData = []
            data.forEach(v => {
              xData.push(v.horizontalAxis)
              yData.push(v.usageNum)
            })
            this.$nextTick(() => {
              this.initEtimeConsumingDetail(xData, yData)
            })
          } else {
            if (!data.length) {
              this.$message.error('暂无数据')
              return
            }
            this.$message.error(message)
          }
        })

    },
    // 作答时间分布二级
    initEtimeConsumingDetail(xData, yData) {
      let that = this
      this.$echarts.init(this.$refs.EtimeConsumingDetailChart).setOption({
        grid: {
          left: 60,
          right: 70,
          top: 40,
          bottom: 40,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          className: "echarts-tooltip",
          formatter: function (val) {
            let time = val[0].name == 0 ? 0 : that.EstimatedTime(+val[0].name);
            return `
						<div>作答时间: <span>${time}</span></div>
						<div>人次: ${val[0].value}</div>`
          }
        },
        xAxis: {
          name: '作答时间',
          nameGap: 15,
          type: 'category',
          data: xData,
          boundaryGap: false,
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          nameGap: 25,
          name: '人次',
          type: 'value'
        },
        series: [
          {
            data: yData,
            type: 'line',
            smooth: true,
            showSymbol: false,
            lineStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                offset: 0,
                color: 'rgba(44,233,255)'
              }, {
                offset: 1,
                color: 'rgb(112,66,251)'
              }])
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(32,203,255, 0.4)'
              }, {
                offset: 1,
                color: 'rgba(32,203,255, 0)'
              }])
            }
          }
        ]
      })
    },
    // 正确率分布
    initEAccuracy() {
      this.$echarts.init(this.$refs.EAccuracyChart).setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (val) {
            let data = val.filter(f => f.value)
            var tit = ''
            var relVal = '';
            for (var i = 0, l = data.length; i < l; i++) {
              tit = `<div>年龄: ${data[i].name}</div>`
              relVal += `
							<div style="display:flex;align-items:center;">
							<div style="width:10px;height:10px;border-radius: 10px;margin-right:10px;backGround:${data[i].color}"></div>
							${data[i].value}人    （${data[i].data.accuracy}%）
							</div>`
            }
            return tit + relVal
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          name: '年龄',
          type: 'category',
          data: this.Evaluationgames.ages,
        },
        yAxis: {
          name: '人数',
          nameGap: 25,
          type: 'value'
        },
        series: [
          {
            name: '0-20%',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Evaluationgames.ageAccuracyList.a
          },
          {
            name: '20%-40%',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Evaluationgames.ageAccuracyList.b
          },
          {
            name: '40%-60%',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Evaluationgames.ageAccuracyList.c
          },
          {
            name: '60%-80%',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Evaluationgames.ageAccuracyList.d
          },
          {
            name: '80%-100%',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Evaluationgames.ageAccuracyList.e
          },
          {
            name: (this.eSearchForm.minAccuracy || '') + '%' + '-' + (this.eSearchForm.maxAccuracy || '') + '%',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Evaluationgames.ageAccuracyList.f
          },
        ]
      })
    },

    /**
     * 训练游戏
     *
     */
    // 使用人数分布
    initTUseCount() {
      this.$echarts.init(this.$refs.TuseCountChart).setOption({
        grid: {
          left: 60,
          right: 40,
          top: 40,
          bottom: 40,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          className: "echarts-tooltip",
          formatter: function (val) {
            return `
						<div>年龄: ${val[0].name}</div>
						<div>人数: <span>${val[0].value}</span></div>
						`
          }
        },
        xAxis: {
          name: '年龄',
          type: 'category',
          data: this.Traingames.age,
          boundaryGap: false,
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          nameGap: 25,
          name: '使用人数',
          type: 'value'
        },
        series: [
          {
            data: this.Traingames.usageNum,
            type: 'line',
            smooth: true,
            showSymbol: false,
            lineStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                offset: 0,
                color: 'rgba(44,233,255)'
              }, {
                offset: 1,
                color: 'rgb(112,66,251)'
              }])
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(32,203,255, 0.4)'
              }, {
                offset: 1,
                color: 'rgba(32,203,255, 0)'
              }])
            }
          }
        ]
      })
    },
    // 关卡作答时间分布
    initTimeConsuming(stage, ageValueObj) {
      let Keys = Object.keys(ageValueObj)
      let TTimeConsuming = this.$echarts.init(this.$refs.TtimeConsumingChart)
      let that = this
      TTimeConsuming.on("click", function (event) {
        that.getTTimeDetail(event)
      })
      console.log(ageValueObj);
      let echartSeries = [];
      for (const key in ageValueObj) {
        console.log(key + '岁');
        echartSeries.push({
          name: key + '岁',
          type: 'bar',
          stack: 'Ad',
          emphasis: {
            focus: 'series'
          },
          data: ageValueObj[key]
        });
      }
      console.log(echartSeries);
      this.$echarts.init(this.$refs.TtimeConsumingChart).setOption({
        grid: {
          left: 60,
          right: 40,
          top: 40,
          bottom: 40,
        },
        legend: {},
        color: ["#2ec7c9", "#b6a2de", "#5ab1ef", "#ffb980", "#d87a80", "#8d98b3", "#e5cf0d", "#97b552", "#95706d", "#dc69aa", "#07a2a4", "#9a7fd1", "#588dd5", "#f5994e", "#c05050", "#59678c", "#c9ab00", "#7eb00a", "#6f5553", "#c14089", "#4ea397", "#22c3aa", "#7bd9a5", "#d0648a", "#f58db2", "#f2b3c9", "#3fb1e3", "#6be6c1", "#626c91", "#a0a7e6", "#c4ebad", "#96dee8", "#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc", '#fd87ab', '#11abff', '#ffdf33', '#968ade', '#c23531', '#2f4554', '#61a0a8', '#d48265', '#749f83', '#ca8622', '#48cda6'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          className: "echarts-tooltip",
          formatter: function (val) {
            let data = val.filter(f => f.value)
            var tit = ''
            var relVal = '';
            for (var i = 0, l = data.length; i < l; i++) {
              let time = data[i].value == 0 ? 0 : that.EstimatedTime(data[i].value);
              tit = `<div>关卡: ${data[i].name}</div>`
              relVal += `
							<div style="display:flex;align-items:center;">
							<div style="width:10px;height:10px;border-radius: 10px;margin-right:10px;backGround:${data[i].color}"></div>
							${data[i].seriesName}: <span>${time}</span>
							</div>`
            }
            return tit + relVal
          }
        },
        xAxis: {
          name: '关卡',
          type: 'category',
          data: stage
        },
        yAxis: {
          name: '平均作答时间',
          type: 'value'
        },
        series: echartSeries
      }, true)
    },
    getTTimeDetail(event) {
      var reg = /[\u4e00-\u9fa5]/g;
      let params = {
        contentId: this.info.id,
        contentVersion: this.eSearchForm.contentVersion,
        StartTime: this.eSearchForm.startTime,
        EndTime: this.eSearchForm.endTime,
        type: 2,
        stage: event.name,
        Age: event.seriesName.replace(reg, "")
      }
      this.$http.GetTrainContentStatisticsByAge(params)
        .then(res => {
          this.$message.destroy();
          const {status, data, message} = res.data;
          if (status && data.length) {
            this.Traingames.visible = true
            this.Traingames.tit = '第' + event.name + '关 & ' + event.seriesName
            let xData = []
            let yData = []
            data.forEach(v => {
              xData.push(v.horizontalAxis)
              yData.push(v.usageNum)
            })
            this.$nextTick(() => {
              this.initTtimeConsumingDetail(xData, yData)
            })
          } else {
            if (!data.length) {
              this.$message.error('暂无数据')
              return
            }
            this.$message.error(message)
          }
        })

    },
    // 作答时间分布二级
    initTtimeConsumingDetail(xData, yData) {
      let that = this
      this.$echarts.getInstanceByDom(this.$refs.TtimeConsumingDetailChart)?.dispose();
      this.$echarts.init(this.$refs.TtimeConsumingDetailChart).setOption({
        grid: {
          left: 60,
          right: 70,
          top: 40,
          bottom: 40,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          className: "echarts-tooltip",
          formatter: function (val) {
            let time = val[0].name == 0 ? 0 : that.EstimatedTime(+val[0].name);
            return `
						<div>作答时间: <span>${time}</span></div>
						<div>人次: ${val[0].value}</div>`
          }
        },
        xAxis: {
          name: '作答时间',
          type: 'category',
          data: xData,
          boundaryGap: false,
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          nameGap: 25,
          name: '人次',
          type: 'value'
        },
        series: [
          {
            data: yData,
            type: 'line',
            smooth: true,
            showSymbol: false,
            lineStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                offset: 0,
                color: 'rgba(44,233,255)'
              }, {
                offset: 1,
                color: 'rgb(112,66,251)'
              }])
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(32,203,255, 0.4)'
              }, {
                offset: 1,
                color: 'rgba(32,203,255, 0)'
              }])
            }
          }
        ]
      }, true)
    },
    // 星星数分布
    initTStart() {
      this.$echarts.getInstanceByDom(this.$refs.TStartChart)?.dispose();
      this.$echarts.init(this.$refs.TStartChart).setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (val) {
            let data = val.filter(f => f.value)
            var tit = ''
            var relVal = '';
            let total = 0
            data.forEach(v => {
              total += v.value
            })
            for (var i = 0, l = data.length; i < l; i++) {
              tit = `<div>关卡: ${data[i].name}</div>`
              relVal += `
							<div style="display:flex;align-items:center;">
							<div style="width:10px;height:10px;border-radius: 10px;margin-right:10px;backGround:${data[i].color}"></div>
							${data[i].value}人   （${(data[i].value / total * 100).toFixed(2)}%）
							</div>`
            }
            return tit + relVal
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          name: '关卡',
          type: 'category',
          data: this.Traingames.stage,
        },
        yAxis: {
          name: '人数',
          nameGap: 25,
          type: 'value'
        },
        series: [
          {
            name: '0星',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Traingames.stageStarList.a
          },
          {
            name: '1星',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Traingames.stageStarList.b
          },
          {
            name: '2星',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Traingames.stageStarList.c
          },
          {
            name: '3星',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Traingames.stageStarList.d
          }
        ]
      }, true)
    },
    // 正确率分布
    initTAccuracy() {
      const minNumber = () => {
        if (!this.eSearchForm.minAccuracy && !this.eSearchForm.maxAccuracy) {
          return ''
        }
        if (!this.eSearchForm.minAccuracy && this.eSearchForm.maxAccuracy) {
          return 0
        }
        return this.eSearchForm.minAccuracy || ''
      }
      const maxNumber = () => {
        if (!this.eSearchForm.minAccuracy && !this.eSearchForm.maxAccuracy) {
          return ''
        }
        if (this.eSearchForm.minAccuracy && !this.eSearchForm.maxAccuracy) {
          return 100
        }
        return this.eSearchForm.maxAccuracy || ''
      }
      this.$echarts.getInstanceByDom(this.$refs.TAccuracyChart)?.dispose();
      this.$echarts.init(this.$refs.TAccuracyChart).setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (val) {
            let data = val.filter(f => f.value)
            var tit = ''
            var relVal = '';
            for (var i = 0, l = data.length; i < l; i++) {
              tit = `<div>关卡: ${data[i].name}</div>`
              relVal += `
							<div style="display:flex;align-items:center;">
							<div style="width:10px;height:10px;border-radius: 10px;margin-right:10px;backGround:${data[i].color}"></div>
							${data[i].value}人   （${data[i].data.accuracy}%）
							</div>`
            }
            return tit + relVal
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          name: '关卡',
          type: 'category',
          data: this.Traingames.stage,
        },
        yAxis: {
          name: '人数',
          nameGap: 25,
          type: 'value'
        },
        series: [
          {
            name: '0-20%',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Traingames.AccuracyList.a
          },
          {
            name: '20%-40%',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Traingames.AccuracyList.b
          },
          {
            name: '40%-60%',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Traingames.AccuracyList.c
          },
          {
            name: '60%-80%',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Traingames.AccuracyList.d
          },
          {
            name: '80%-100%',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Traingames.AccuracyList.e
          },
          {
            name: minNumber() + '%' + '-' + maxNumber() + '%',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: this.Traingames.AccuracyList.f
          },
        ]
      }, true)
    },
    // 作答次数分布
    answerChart() {
      this.$nextTick(() => {
        if (!this.answer.xAxisData.length) {
          return
        }
        this.$echarts.getInstanceByDom(this.$refs.answerCharDom)?.dispose();
        this.$echarts.init(this.$refs.answerCharDom).setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            // formatter: '{a}aa'
          },

          legend: {},
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            name: '关卡',
            type: 'category',
            axisLabel: {
              formatter: function (value) {
                return value.split("：")[1]
              },
            },
            data: this.answer.xAxisData,
          },
          yAxis: {
            name: '人数',
            nameGap: 25,
            type: 'value'
          },
          series: this.answer.series
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
p {
  color: #1890ff;
  text-indent: 60px;
  font-size: 16px;
  margin-top: 50px;
}

.head {
  display: flex;
  justify-content: space-between;
}

.head /deep/ .ant-form-item label {
  position: relative;
  display: block;
  line-height: 31px;
}

.chart {
  position: relative;
}

.noData {
  width: 100%;
  height: 300px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}

.loadingPage {
  width: 100%;
  /* position: fixed; */
  top: 0;
  left: 0;
  background: #fff;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.vename {
  display: flex;
  align-items: center;
}
</style>
